module.exports = __webpack_public_path__ + "static/img/14.38b4a7a9.png";